import { render } from "./FlashPage.vue?vue&type=template&id=d9451fe8"
import script from "./FlashPage.vue?vue&type=script&lang=js"
export * from "./FlashPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\chk-sop-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__